import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { TechSection } from './components/TechSection';
import { ServicesSection } from './components/ServicesSection';
import { CoverageSection } from './components/CoverageSection';
import { SecuritySection } from './components/SecuritySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { PrivacyPage } from './pages/PrivacyPage';
import { SalesConditionsPage } from './pages/SalesConditionsPage';
function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <TechSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <CoverageSection data-id="element-7" />
        <SecuritySection data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
        <Route path="/privacidad" element={<PrivacyPage data-id="element-16" />} data-id="element-15" />
        <Route path="/condiciones" element={<SalesConditionsPage data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}